<template>
  <section-box v-if="viewedBy.length" class="viewed_by_box">
    <p class="viewed_by_box--text">Record being viewed by {{ viewedByString }}</p>
  </section-box>
</template>

<script>
export default {
  name: "LeadViewedBy",
  props: {
    viewedBy: {
      type: Array,
      required: true,
    },
  },
  computed: {
    viewedByString() {
      let string = "";

      this.viewedBy.forEach(user => {
        string += user.full_name + ", ";
      });

      return string.trim().slice(0, -1);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.viewed_by_box {
  margin-bottom: $modalGutter;
  padding-top: 12px;
  padding-bottom: 12px;
  border-left: 5px solid $primary;

  &--text {
    font-style: italic;
    color: $text-muted;
    line-height: 1.35;
  }
}
</style>
